<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fas fa-person-digging"></i> Munkahelyek</h1>
            </div>
            <div class="ms-auto" v-if="user && user.role_id == 1">
                <button class="btn btn-success btn-rounded px-4 rounded-pill" @click="openCreate(null)"><i
                        class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új Részterület</button>
                <b-modal id="createModal" @ok="sendWorkplace">
                    <template slot="modal-header">
                        <h4 class="modal-title">{{ workplace.parent_id == null ? 'Részterület' : 'Üzem' }} létrehozása</h4>
                        <a class="btn-close" @click="closeAddModal()"></a>
                    </template>
                    <Loading title="Létrehozás" v-if="loading"></Loading>
                    <div v-else>
                        <label class="form-label">Név:</label>
                        <input type="text" class="form-control" v-model="workplace.name">
                        <div class="invalid-feedback d-block" v-if="errors.name">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                    <template #modal-footer="{ cancel, ok }">
                        <b-button variant="default" @click="cancel()">
                            Mégse
                        </b-button>
                        <b-button variant="primary" @click="ok()">Mentés</b-button>
                    </template>
                </b-modal>
            </div>
        </div>
        <panel title="Részterületek">
            <Loading v-if="workplaces === false"></Loading>
            <NoRecords v-else-if="workplaces.length == 0" main_icon="fa fa-person-digging" title="Nincsenek munkahelyek">
            </NoRecords>
            <div class="table-responsive" v-else>
                <table class="table table-striped">
                    <thead class="table-dark">
                        <tr>
                            <th></th>
                            <th>Megnevezés</th>
                            <th>Üzemek</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(workplace, id) in workplaces" :key="id">
                            <td width="10%">
                                <template v-if="user.role_id == 1">
                                    <button class="btn btn-xs btn-warning" title="szerkesztés" @click="openEdit(workplace)"><i
                                        class="fa fa-pencil"></i></button>
                                        <button class="btn btn-xs btn-danger ms-1" title="törlés" v-if="workplace.children.length == 0" @click="deleteWorkplace(workplace)"><i
                                            class="fa fa-trash"></i></button>
                                </template>
                            </td>
                            <td>{{ workplace.name }}</td>
                            <td>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th><button v-if="user.role_id == 1" class="btn btn-success btn-xs" @click="openCreate(workplace.id)"><i
                                                        class="fa fa-plus"></i> új üzem</button></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(child, cid) in workplace.children" :key="cid">
                                            <td>{{ child.name }}</td>
                                            <td class="text-end">
                                                <template v-if="user.role_id == 1">
                                                    <button class="btn btn-xs btn-warning" title="szerkesztés"
                                                    @click="openEdit(child)"><i class="fa fa-pencil"></i></button>
                                                    <button class="btn btn-xs btn-danger ms-1" title="törlés" v-if="child.user_count == 0" @click="deleteWorkplace(child)"><i
                                                        class="fa fa-trash"></i></button>
                                                    </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-modal id="editModal" @ok="updateWorkplace">
                    <template slot="modal-header">
                        <h4 class="modal-title">{{ workplace.parent_id == null ? 'Részterület' : 'Üzem' }} szerkesztése</h4>
                        <a class="btn-close" @click="closeEditModal()"></a>
                    </template>
                    <Loading title="Frissítés" v-if="loading"></Loading>
                    <div v-else>
                        <label class="form-label">Név:</label>
                        <input type="text" class="form-control" v-model="workplace.name">
                        <div class="invalid-feedback d-block" v-if="errors.name">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                    <template #modal-footer="{ cancel, ok }">
                        <b-button variant="default" @click="cancel()">
                            Mégse
                        </b-button>
                        <b-button variant="primary" @click="ok()">Mentés</b-button>
                    </template>
                </b-modal>
            </div>
        </panel>
    </div>
</template>

<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import Workplace from '../../apis/Workplace';
import Confirmation from '../../apis/Confirmation';
export default {
    components: {
        Loading, NoRecords
    },
    data() {
        return {
            workplaces: false,
            workplace: {
                parent_id: null,
                name: null,
            },
            loading: false,
            errors: []
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        Workplace.index().then(response => {
            this.workplaces = response.data;
        })
    },
    methods: {
        openCreate(parent_id) {
            this.workplace.parent_id = parent_id;
            this.$bvModal.show('createModal');
        },
        openEdit(workplace) {
            this.workplace = Object.assign({},workplace);
            this.$bvModal.show('editModal');
        },
        sendWorkplace(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.loading = true;
            Workplace.store(this.workplace).then(response => {
                this.closeAddModal();
                if (response.data.parent_id != null) {
                    this.workplaces.find(w => w.id == response.data.parent_id).children.push(response.data);
                } else {
                    this.workplaces.push(response.data);
                }
            }).catch(error => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        updateWorkplace(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.loading = true;
            Workplace.update(this.workplace.id, this.workplace).then(response => {
                this.closeUpdateModal();
                if (response.data.parent_id != null) {
                    let parent = this.workplaces.find(w => w.id == response.data.parent_id); 
                    parent.children[parent.children.findIndex(w => w.id == response.data.id)] = response.data;
                }else{
                    this.workplaces[this.workplaces.findIndex(w => w.id == response.data.id)] = response.data;
                }
            }).catch(error => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        closeAddModal() {
            this.$bvModal.hide('createModal');
            this.resetWorkplace();
        },
        closeUpdateModal() {
            this.$bvModal.hide('editModal');
            this.resetWorkplace();
        },
        deleteWorkplace(workplace) {
            Confirmation.swalDelete().then(response => {
				if(response.isConfirmed === true){
                    Workplace.delete(workplace.id).then(() => {
                        if(workplace.parent_id){
                            let parent = this.workplaces.find(w => w.id == workplace.parent_id);
                            parent.children.splice(parent.children.findIndex(w => w.id == workplace.id),1);
                        }else{
                            this.workplaces.splice(this.workplaces.findIndex(w => w.id == workplace.id),1);
                        }
                    });
                }
            });
        },
        resetWorkplace() {
            this.workplace = {
                parent_id: null,
                name: null,
            };
        }
    }
}
</script>